import { batch, connect } from 'react-redux'
import { actions } from '../../store/registeredUserDetail'

function mapStateToProps(state) {
  return {
    userDetail: state.registeredUserDetail.userDetail,
    savedSearches: state.registeredUserDetail,
    authUser: state.auth || {},
    groups: state.registeredUserDetail.groups || [],
    savedSearchesTotal: state.registeredUserDetail.count,
    savedSearchesSelected: state.registeredUserDetail.savedSearchesSelected,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    findOne: params => dispatch(actions.findOne(params)),
    addGroupSavedSearches: ids =>
      dispatch(actions.addGroupSavedSearchesAction(ids)),
    removeGroupSavedSearches: ids =>
      dispatch(actions.removeGroupSavedSearchesAction(ids)),
    addOneSavedSearches: params =>
      dispatch(actions.addOneSavedSearchesAction(params)),
    removeOneSavedSearches: params =>
      dispatch(actions.removeOneSavedSearchesAction(params)),
    saveDataAfterDeleteSearch: params =>
      dispatch(actions.saveDataAfterDeleteSearchAction(params)),
    saveDataAfterDeleteBulkSearch: params =>
      dispatch(actions.saveDataAfterDeleteBulkSearchAction(params)),
    onInitSavedSearches: async filterByUserId => {
      batch(() => {
        dispatch(actions.restartStateAction())
        dispatch(actions.setParams({ filterByUserId, userName: filterByUserId }))
      })
      await dispatch(actions.fetchList())
    },
    savedSearchesActions: {
      onSave: params =>
        batch(async () => {
          await dispatch(actions.saveSearchAction(params))
          await dispatch(actions.fetchList())
        }),
      onDelete: params =>
        batch(async () => {
          await dispatch(actions.deleteSearchAction(params))
          await dispatch(actions.fetchList())
        }),
      onWatch: params =>
        batch(async () => {
          await dispatch(actions.toggleWatchAction(params))
          await dispatch(actions.fetchList())
        }),
      onFindOne: params =>
        batch(async () => {
          await dispatch(actions.findOneSearchAction(params))
        }),
      onTurnOnOffNotifications: params =>
        batch(async () => {
          await dispatch(actions.turnOnOffNotificationsAction(params))
          await dispatch(actions.findOne({ id: params.idSavedSearchOwner }))
        }),
      onDeleteBulk: params =>
        batch(async () => {
          await dispatch(actions.deleteBulkSearchAction(params))
          await dispatch(actions.fetchList())
        }),
      onGetSavedSearchStats: async params => {
        let resp = null
        try {
          const { payload } = await dispatch(
            actions.getSavedSearchStats(params)
          )
          resp = payload
        } catch (error) {
          resp = error
        }
        return resp
      },
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)
